import type { AnalysisData } from "../types";

export function downloadJson(data: AnalysisData): void {
  const safe = {
    exported_at: new Date().toISOString(),
    source: data.sourceName,
    summary: {
      windows: data.windows.length,
      alerts: data.alerts.length,
      incidents: data.incidents.length,
      readiness: data.readiness,
      quality: data.quality,
      drift: data.drift,
    },
    alerts: data.alerts,
    incidents: data.incidents,
  };
  const url = URL.createObjectURL(new Blob([JSON.stringify(safe, null, 2)], { type: "application/json" }));
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = `ueba-investigation-${new Date().toISOString().slice(0, 10)}.json`;
  anchor.click();
  URL.revokeObjectURL(url);
}
